import React from 'react';
import { useLocation } from 'react-router-dom';
import ContactForm from './ContactForm';
import { contactInfo } from '../data';

export default function SharedBottomSections() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isKontaktPage = location.pathname === '/kontakt';

  return (
    <>
      {/* Den mørkegrønne kontakt-sektion vises på undersider, men fjernes fra forsiden og kontaktsiden */}
      {!isHomePage && !isKontaktPage && (
        <section id="kontakt-sektion" className="bg-teal-900 py-24 border-t border-teal-800">
          <div className="max-w-[1600px] mx-auto px-6 sm:px-8 lg:px-12">
            <div className="grid lg:grid-cols-2 gap-16 items-start">
              <div>
                <div className="inline-block bg-orange-500/10 text-orange-400 px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider mb-6">
                  Kontakt os i dag for en uforpligtende snak om din opgave.
                </div>
                <h2 className="text-4xl font-black text-white mb-8 leading-[1.15] tracking-tight">
                  Få et uforpligtende tilbud på malerarbejde
                </h2>
                <div className="prose prose-lg text-teal-100/90 space-y-6 mb-10">
                  <p>
                    Når du kontakter Syddansk Malerfirma, må du meget gerne beskrive opgaven så konkret som muligt. Det gør det lettere at vurdere arbejdet og vende tilbage med den rette rådgivning.
                  </p>
                  <p>
                    Skriv gerne, hvilke rum eller områder der skal males, og om det drejer sig om vægge, lofter, træværk, facade eller andet malerarbejde. Du må også gerne nævne cirka størrelse, nuværende stand, ønsket tidspunkt, og om der er særlige forhold, vi skal være opmærksomme på.
                  </p>
                  <p>
                    Jo flere oplysninger vi får fra start, desto nemmere er det at give dig et godt og realistisk svar uden unødvendige spørgsmål frem og tilbage. Du er altid velkommen til at bruge kontaktformularen eller ringe direkte, hvis du vil tage en snak om opgaven.
                  </p>
                </div>

                <div className="grid sm:grid-cols-2 gap-8">
                  <div className="bg-teal-950/50 p-6 rounded-2xl shadow-sm border border-teal-800">
                    <p className="text-sm font-bold text-orange-500 uppercase tracking-widest mb-2">Ring til os</p>
                    <a href={`tel:${contactInfo.phone}`} className="text-2xl font-bold text-white hover:text-teal-300 transition-colors">
                      {contactInfo.phone}
                    </a>
                  </div>
                  <div className="bg-teal-950/50 p-6 rounded-2xl shadow-sm border border-teal-800">
                    <p className="text-sm font-bold text-orange-500 uppercase tracking-widest mb-2">Skriv til os</p>
                    <a href={`mailto:${contactInfo.email}`} className="text-lg font-bold text-white hover:text-teal-300 transition-colors break-words">
                      {contactInfo.email}
                    </a>
                  </div>
                </div>

                <div className="mt-12 flex items-center gap-4">
                  <div className="bg-white px-5 py-2 rounded-xl flex items-center justify-center h-16 shadow-sm">
                    <img 
                      src="https://assets.auxodev.dk/assets/656b4e51-500c-4bf5-9ac7-27acb4e8635e/9a931652-82a1-42a7-bfb8-d6f9d61651ab.png" 
                      alt="Syddansk Malerfirma Logo" 
                      className="h-12 w-auto object-contain" 
                    />
                  </div>
                  <div className="h-8 w-px bg-teal-800"></div>
                  <p className="text-teal-200/70 font-medium">Din lokale maler i Sønderborg & omegn</p>
                </div>
              </div>
              
              <div className="bg-teal-950/50 p-6 sm:p-10 rounded-2xl sm:rounded-3xl shadow-xl border border-teal-800 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-32 h-32 bg-orange-500/5 rounded-bl-full -mr-16 -mt-16"></div>
                <div className="relative z-10">
                  <h3 className="text-3xl font-black text-white mb-4 tracking-tight leading-[1.15]">Få et uforpligtende tilbud</h3>
                  <p className="text-teal-100/80 mb-8 text-lg">Udfyld formularen herunder og vi vender tilbage med et uforpligtende tilbud inden for 48 timer.</p>
                  <ContactForm />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}
